import React from "react";

import { useLanguage } from "../../contexts/LanguageContext";

import "./Footer.css";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer" style={{ padding: "0" }}>
      <div className="footer-bottom" style={{ padding: "20px" }}>
        <p>{t("footer.allRightsReserved")}</p>
        <div className="footer-row">
          <ul>
            <li>
              <a href="/">{t("footer.home")}</a>
            </li>
            <li>
              <a href="/contact">{t("footer.contact")}</a>
            </li>
            <li>
              <a href="/privacy">{t("footer.privacyPolicy")}</a>
            </li>
            <li>
              <a href="/terms">{t("footer.termsOfService")}</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
